import { UsersService } from './users.service';
import { Router } from '@angular/router';
import { SettingsService } from './settings.service';
import { Site } from './../models/site';
import { AuthService } from './auth.service';
import { Member } from './../models/member';
import { Company } from './../models/company';
import { Folder } from './../models/folder';
import { Injectable } from '@angular/core';
import { AngularFireDatabase, FirebaseListObservable, FirebaseObjectObservable } from 'angularfire2/database';
import { Observable } from 'rxjs';
import * as _ from 'lodash';

@Injectable()
export class CompanyService {

  companies: FirebaseListObservable<any[]>;
  company: FirebaseObjectObservable<any>;
  folders : FirebaseListObservable<any[]>;
  members : FirebaseListObservable<any[]>;
  folders_count : number;
  //userRoles: Array<string>;

constructor(
  private af:AngularFireDatabase,
  public auth: AuthService,
  public settingsService: SettingsService,
  public userService: UsersService,
  public router: Router
) {
    this.companies = this.af.list('/companies') as FirebaseListObservable<Company[]>;
}


getCompanies(){
  return this.companies;
}
getCompany(id:string){
  return this.af.object('/companies/'+id) as FirebaseObjectObservable<Company>;
}
getCompanyMembers(id:string){
  return this.af.list('/companies/'+id+'/members') as FirebaseListObservable<any[]>;
}

getNewCompanyMembers(id:string){
  this.members = this.af.list('/companies/'+id+'/members') as FirebaseListObservable<any[]>;
}

getCompanySecret(secret:string){
  return this.af.list('/companies',{
    query: {
      orderByChild: 'companySecret',
      equalTo: secret
    }
  }) as FirebaseListObservable<any[]>;
}

getFolder(id:string,cId:string){
  return this.af.object('/company_folders/'+cId+'/'+id) as FirebaseObjectObservable<Company>;
}


getCompanyFolder(id:string){
  return this.af.object('/company_folders/'+id) as FirebaseObjectObservable<Company>;
}

getCompanyFolders(id:string){
  return this.af.list('/company_folders/'+id) as FirebaseListObservable<any[]>;
}

getCompanyPicturesFolders(companyId:string,folderID, limit:number = 8){
  return this.af.list('/uploads/'+companyId+'/'+ folderID + '/files',{
    query: {
      orderByKey: true,
      limitToLast: limit,
    }
  }) as FirebaseListObservable<any[]>;
}

setRawCompanyData(companyId:string, data: any) {
  console.log('DATA', data, 'company', companyId)
  return this.companies.update(companyId, data);
}

updateCompany(id:string, entreprise: Company){
  if( this.auth.canEdit ) {
    return this.companies.update(id, entreprise);
  } else console.log('action prevented');

}
updateRaw(id:string, commentCount:number){
   return this.companies.update(id, {foldersCount : this.folders_count});
}

// update user data  a faire pour mettre a jour les données

activateCompany(id:string, value:any){
  return this.companies.update(id, value);
}

newMemberWithSecret(cId: string, companyName: string, member: Member){

  this.settingsService.changeSettings( { currentCompany: cId, currentCompanyName: companyName } );
  this.userService.setUserWithCompany({isSecretSet : true, isRegistered : true})

  this.addMember(cId, member)
    .then(()=> {
      this.addMemberCompany(member.uid, cId, companyName)
      .then(() => {
        console.log('Membre ajouté')
      })
      .catch(err => console.log(err))
    })
    .catch(err => console.log(err, 'Failed'));
  }

addMemberWithSecret(secret:string, member: Member){

  this.getCompanySecret(secret).take(1).subscribe(comp => {
    if(comp[0]){
      let cId = comp[0].$key;
      let companyName = comp[0].companyName;
      let companyArchiveFolder = comp[0].archiveFolder
    //  console.log('dans company service avec valeur ', companyName, 'CID COMP',cId,'membre ', member);
      this.userService.itemChangeUser(member.uid , {isSecretSet : true, isRegistered : true})
      this.settingsService.changeSettings( { currentCompany: cId, currentCompanyName: companyName, archiveFolder: companyArchiveFolder } );

      this.af.list('/companies/' + cId + '/members/').update(
        member.uid,{ uid : member.uid , name : member.displayName, background: member.background, email: member.email }
      ).then(() => {
          this.af.list('/members_company/' + member.uid).update(cId, {principale: 'true',companyName: companyName})
            .then(() => console.log('ajouté'));
            this.router.navigate ( [ '/' ] );
      })
       .catch(err => console.log(err,'Failed'));

    } else {
      this.router.navigate ( [ 'session/signup' ] );
    }
  })
}
addMemberCompany(mId: string, cId: string, companyName: string ){
  return this.af.list('/members_company/' + mId).update(cId, {principale: 'true', companyName: companyName})
}

addMember(cId: string, member : Member ){
  this.members = this.af.list('/companies/'+ cId + '/members/');
  return this.members.update(member.uid, {uid: member.uid , name: member.displayName, background: member.background, email: member.email });
}

newCompany( entreprise: Company, member : Member ){
    return this.companies.push(entreprise).then((item) => {
      this.addMember(item.key, member);
      this.af.list('/members_company/' + member.uid).update(item.key, { principale: 'true', companyName: entreprise.companyName})
      .then(() => console.log('ajouté'));
    });
}

deleteCompany(id:string){
  if (this.auth.canDelete) {
    return this.companies.remove(id);
  }
}


// gestion des sites physiques
newSite(companyId: string, site: Site){
  return  this.af.list('/company_sites/' + companyId ).push(site); // as FirebaseListObservable<any[]>;
}
getSites(companyId:string){
  return this.af.list('/company_sites/' + companyId) as FirebaseListObservable<Site[]>;
}

deleteSite(iUid: string, cUid: string){
  return this.af.list('/company_sites/' + iUid ).remove(cUid);
}

getSite(id:string,companyId:string ){
   return this.af.object('/company_sites/' + companyId + '/' + id) as FirebaseObjectObservable<Site>;
}

updateSite(companyId: string, cUid: string, tons: any, b: string){
  return  this.af.object(`/company_sites/${companyId}/${cUid}/${b}`).set(tons); // as FirebaseListObservable<any[]>;
}

// gestion des dossiers   -KwWt49YRmDCWmAmJAhR

  newCompanyFolder( id:string,folder:any){
    this.folders = this.af.list('/company_folders/'+id) as FirebaseListObservable<Folder[]>;
    let f = new Folder({folderName:folder.folderName , folderDescription: folder.folderDescription})
    return  this.af.list('/company_folders/' + id).push(f); //as FirebaseListObservable<any[]>;
  }

  deleteCompanyFolder(companyId: string, fId:string){
           this.af.list('/uploads/' + companyId ).remove(fId)
    return this.af.list('/company_folders/' + companyId ).remove(fId);
  }

  deleteCompanyPictureInFolder(companyId: string, fId: string, dId: string ){
    this.af.list('/uploads/' + companyId + '/' + dId + '/files'  ).remove(fId)
  }

  moveCompanyFolder(companyId: string, fromId: string, toId: string) {
   const reference =  this.af.app.database().ref('/uploads/' + companyId);
    reference.child(fromId).once('value')
    .then(function(snapshot) {
     snapshot.child('files').forEach(file => {
      reference.child(toId + '/files').push(file.val());
    });
   })
  }

  moveCompanyPictureToFolder(companyId: string, fId: string, fromId: string, toId: string) {
    const reference =  this.af.app.database().ref('/uploads/' + companyId );
    reference.child( fromId + '/files/' + fId).once('value')
    .then(function(snapshot) {      
      reference.child(toId + '/files').push(snapshot.val());
    });
  }
  // gestion des taches
  newTodo(companyId: string, message:any) {
    return  this.af.list('/company_todos/' + companyId ).push(message); // as FirebaseListObservable<any[]>;
  }

  updateTodo(companyId: string,  message:any){
    return  this.af.list('/company_todos/' + companyId ).update(message.$key, message); // as FirebaseListObservable<any[]>;
  }

  getTodos(companyId:string){
    return this.af.list('/company_todos/' + companyId) as FirebaseListObservable<any[]>;    
  }
  deleteTodos(iUid: string, cUid: string){
    return this.af.list('/company_todos/' + iUid ).remove(cUid);
  }

}



// WEBPACK FOOTER //
// /Volumes/MACOS-START/Outside/SITE Co-WORKING/ng/src/app/services/company.service.ts